// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    margin: 0px;
    padding: 0px;
    background-color: #141414;
    /* background-color: #282828; */
    /* background-color: #cccccc; */
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    height: 100%;
}

#feedback{
    position: fixed;
    display: none;
    z-index:50000;
    color:aliceblue;
    background-color: rgb(0, 0, 0);
}

#versionOverlay {
    position: fixed;
    left: 14px;
    bottom: 14px;
    z-index: 200000;
    display: none;
    padding: 6px 10px;
    font-family: "Rajdhani", sans-serif;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.06em;
    color: #c8c8c8;
    background: rgba(20, 20, 20, 0.92);
    border: 1px solid #444444;
    border-radius: 2px;
    pointer-events: none;
}

#versionOverlay.is-visible {
    display: block;
}

#loadingImage{
    position: fixed;
    width: 237px;
    height: 46px;

    font-family: 'Gotham-Book';
    color: #333333;
    font-size: 20pt;
    text-align: center;
    
    top:0;
    bottom:0;
    left: 0;
    right: 0;
    margin:auto;
    z-index: 11000;

    image-rendering: smooth ;
    pointer-events: none;
    display: none;
}

#loadingBack{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index:10000;
    background-color: rgb(0, 0, 0);
    pointer-events: none;
    display: none;
}
/* 
.backCanvas{
    position: fixed;
    top: 0px;
    z-index: 120;
    border: 2px solid red;
} */

#canvasHolder {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 0;
    pointer-events: none;
    /* border: 2px solid red; */
}

.crt-scanlines {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 3;
    background: repeating-linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.08) 0px,
        rgba(0, 0, 0, 0.08) 2px,
        transparent 2px,
        transparent 4px
    );
    mix-blend-mode: multiply;
}

.crt-vignette {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 4;
    background: radial-gradient(
        ellipse at center,
        transparent 40%,
        rgba(0, 0, 10, 0.72) 100%
    );
}

.pageGradient {
    display: none;
}

body.crt-bg-active {
    background: #000000;
}

body.crt-bg-active .pageGradient {
    display: block;
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 5;
    opacity: 0;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
    );
}

body.crt-print-page {
    background: #000000 !important;
}

body.crt-print-page .pageGradient,
body.crt-print-page .crt-scanlines,
body.crt-print-page .crt-vignette {
    display: none !important;
}

#canvasHolder canvas.backCanvas {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

body.crt-bg-active #canvasHolder canvas.backCanvas {
    opacity: 0;
}

.gradientDiv {
    position: fixed;
    left: -180%;
    top: -1000px;
    width: 360%;
    height: 2000px;
    background: radial-gradient(circle, rgba(235, 0, 0, .15) 0%, rgba(235, 0, 0, 0) 50%);
    z-index: 0;
    pointer-events: none;
}

body.crt-bg-active .gradientDiv {
    display: none;
}

/* bar */

#topBar {
    position: fixed;
    width: 100%;
    /* height: 50px; */
    height: 0;
    background-color: white;
    display: flex;
    align-items: center;
    opacity: 1;
    z-index: 100;
    
}

#topBarGrad{
    position: fixed;
    top: 50px;
    width: 100%;
    height: 30px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), transparent);
    z-index: 99;
    opacity: 0;
}

#leftBar {
    position: fixed;
    top: 15px;
    left: 115px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    flex-wrap: wrap;
    max-width: 900px;
    z-index: 100;
    
}

#rightBar {
    position: fixed;
    top: 15px;
    right: 30px;
    width: 500px;
    text-align: right;
    z-index: 100;
}

#logo {
    position: fixed;
    top: 16px;
    left: 25px;
    height: 22px;
    z-index: 100;
    opacity: 0;
}

#centerLogo{
    position: fixed;
    left: 50%;
    top: 48%;
    transform: translate(-50%, -50%);
    width: 160px;
    z-index: 100110;
    pointer-events: none;
    /* border: 1px solid red; */
}

#hamburger {
    position: fixed;
    top: 15px;
    right: 10px;
    width: 40px;
    display: none;
    z-index: 100;
    pointer-events: none;
}

.linkButton {
    font-family: "Rajdhani", sans-serif;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 1px;
    color: #333333;
    padding-right: 14px;
    display: inline-block;
    cursor: pointer;
    /* transition: transform 0.3s ease-in; */
    opacity: 0;
}

.linkButton:hover {
    text-decoration: underline;  /* Underline on hover */
    color: #333333;  /* Optional: Change color on hover */
}

.linkButton:hover {
    /* transform: translateY(-2px); */
    /* transition: transform 0.04s ease-out; */
}
  
#mainDivCont{

    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    z-index: 10;
    /* opacity: 0; */

    /* -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */
    /* mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */

}

#mainDiv{
    position: absolute;
    width: 100%;
    /* border: 1px solid red; */
}

#cursor {
    position: fixed;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    z-index: 200;
    background: #ffffff;
    opacity: .1;
    pointer-events: none;
}

#cursor2 {
    position: fixed;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    z-index: 200;
    /* background: #ffffff; */
    border: 1px solid white;
    opacity: .2;
    pointer-events: none;
}

#tr1 {
    opacity: 0;
}

#tr2 {
    opacity: 0;
}

#tr3 {
    opacity: 0;
}

#tr4 {
    opacity: 0;
}

#tr5 {
    opacity: 0;
}

#tr6 {
    opacity: 0;
}

#tr7 {
    opacity: 0;
}

#contactCont{
    
    color: #cccccc;
    position: fixed;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    /* border: 1px solid red; */
    transform: translateY(-10%);
    gap: 5px;
}

#contact1{
    font-family: "IM Fell English", serif;
    font-style: italic;
    font-size: 16pt;
}

#contact2{
    font-family: "Rajdhani", sans-serif;
    font-size: 16pt;
    letter-spacing: 2px;
}

#contact3{
    font-family: "Rajdhani", sans-serif;
    font-size: 10pt;
    letter-spacing: 2px;
}

#contactCont #contact3 a:hover {
    color: #cccccc;
    text-decoration: none;
  }
  
#contact3 a,
#contact3 a:link,
#contact3 a:visited,
#contact3 a:hover,
#contact3 a:active {
  color: #cccccc !important;
  text-decoration: none;
}

.tmzLink {
    color: #cccccc;
    text-decoration: underline;
  }

@media (max-width: 1370px) {
    #leftBar {
        top: 7px;
        max-width: 450px;
        /* border: 1px solid red; */
    }
}

@media (max-width: 960px) {
    #tr1 {
        display: none;
    }
    #tr2 {
        display: none;
    }
    #tr3 {
        display: none;
    }
    #tr4 {
        display: none;
    }
}

@media (max-width: 715px) {
    #canvasHolder,
    .crt-scanlines,
    .crt-vignette,
    .pageGradient {
        display: none !important;
    }
    #leftBar {
        display: none;
    }
    #rightBar {
        display: none;
    }
    #topBar {
        display: none;
    }
    #logo{
        top: 15px;
        left: 15px;
        height: 25px;
    }
    #hamburger{
        /* display: block; */
    }
    #topBarGrad{
        /* display: none; */
        top: 0px;
    }
    
}

#hamburgerMenu {
    /* display: none; */
    opacity: 0;
    position: fixed;
    top: 50px;
    right: 10px;
    background-color: black;
    /* padding: 10px; */
    z-index: 1200;
    border: 1px solid #444;
  }
  
  .hamburgerLink {
    font-family: "Rajdhani", sans-serif;
    font-size: 14px;
    letter-spacing: 1px;
    color: #cccccc;
    padding: 8px 12px;
    border-bottom: 1px solid #444444;
    cursor: pointer;
  }
  
  .hamburgerLink:last-child {
    border-bottom: none;
  }
  
  .hamburgerLink:hover {
    background-color: #222;
  }
  

/* ------links--------------------------------------------------- */

/*  */
  
/* mixer */

#mixer{
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;;IAEZ,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,kBAAkB;;IAElB,KAAK;IACL,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,cAAc;;IAEd,wBAAwB;IACxB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,aAAa;AACjB;AACA;;;;;;GAMG;;AAEH;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;;;;;KAMC;IACD,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;;;KAIC;AACL;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV,UAAU;IACV;;;;KAIC;AACL;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,cAAc;IACd,oFAAoF;IACpF,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA,QAAQ;;AAER;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uEAAuE;IACvE,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,0BAA0B,GAAG,uBAAuB;IACpD,cAAc,GAAG,oCAAoC;AACzD;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;AAC9C;;AAEA;;IAEI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,WAAW;IACX,gBAAgB;;IAEhB,mGAAmG;IACnG,2FAA2F;;AAE/F;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;EACvB;;AAEF;;;;;EAKE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;EAC5B;;AAEF;IACI;QACI,QAAQ;QACR,gBAAgB;QAChB,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;;;;QAII,wBAAwB;IAC5B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,SAAS;QACT,UAAU;QACV,YAAY;IAChB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,QAAQ;IACZ;;AAEJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF,mEAAmE;;AAEnE,KAAK;;AAEL,UAAU;;AAEV;IACI,aAAa;AACjB","sourcesContent":["body{\n    margin: 0px;\n    padding: 0px;\n    background-color: #141414;\n    /* background-color: #282828; */\n    /* background-color: #cccccc; */\n    user-select: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    height: 100%;\n}\n\n#feedback{\n    position: fixed;\n    display: none;\n    z-index:50000;\n    color:aliceblue;\n    background-color: rgb(0, 0, 0);\n}\n\n#versionOverlay {\n    position: fixed;\n    left: 14px;\n    bottom: 14px;\n    z-index: 200000;\n    display: none;\n    padding: 6px 10px;\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    color: #c8c8c8;\n    background: rgba(20, 20, 20, 0.92);\n    border: 1px solid #444444;\n    border-radius: 2px;\n    pointer-events: none;\n}\n\n#versionOverlay.is-visible {\n    display: block;\n}\n\n#loadingImage{\n    position: fixed;\n    width: 237px;\n    height: 46px;\n\n    font-family: 'Gotham-Book';\n    color: #333333;\n    font-size: 20pt;\n    text-align: center;\n    \n    top:0;\n    bottom:0;\n    left: 0;\n    right: 0;\n    margin:auto;\n    z-index: 11000;\n\n    image-rendering: smooth ;\n    pointer-events: none;\n    display: none;\n}\n\n#loadingBack{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index:10000;\n    background-color: rgb(0, 0, 0);\n    pointer-events: none;\n    display: none;\n}\n/* \n.backCanvas{\n    position: fixed;\n    top: 0px;\n    z-index: 120;\n    border: 2px solid red;\n} */\n\n#canvasHolder {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 0;\n    pointer-events: none;\n    /* border: 2px solid red; */\n}\n\n.crt-scanlines {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 3;\n    background: repeating-linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.08) 0px,\n        rgba(0, 0, 0, 0.08) 2px,\n        transparent 2px,\n        transparent 4px\n    );\n    mix-blend-mode: multiply;\n}\n\n.crt-vignette {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 4;\n    background: radial-gradient(\n        ellipse at center,\n        transparent 40%,\n        rgba(0, 0, 10, 0.72) 100%\n    );\n}\n\n.pageGradient {\n    display: none;\n}\n\nbody.crt-bg-active {\n    background: #000000;\n}\n\nbody.crt-bg-active .pageGradient {\n    display: block;\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 5;\n    opacity: 0;\n    background: linear-gradient(\n        to bottom,\n        rgba(0, 0, 0, 1) 0%,\n        rgba(0, 0, 0, 0) 100%\n    );\n}\n\nbody.crt-print-page {\n    background: #000000 !important;\n}\n\nbody.crt-print-page .pageGradient,\nbody.crt-print-page .crt-scanlines,\nbody.crt-print-page .crt-vignette {\n    display: none !important;\n}\n\n#canvasHolder canvas.backCanvas {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\nbody.crt-bg-active #canvasHolder canvas.backCanvas {\n    opacity: 0;\n}\n\n.gradientDiv {\n    position: fixed;\n    left: -180%;\n    top: -1000px;\n    width: 360%;\n    height: 2000px;\n    background: radial-gradient(circle, rgba(235, 0, 0, .15) 0%, rgba(235, 0, 0, 0) 50%);\n    z-index: 0;\n    pointer-events: none;\n}\n\nbody.crt-bg-active .gradientDiv {\n    display: none;\n}\n\n/* bar */\n\n#topBar {\n    position: fixed;\n    width: 100%;\n    /* height: 50px; */\n    height: 0;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    opacity: 1;\n    z-index: 100;\n    \n}\n\n#topBarGrad{\n    position: fixed;\n    top: 50px;\n    width: 100%;\n    height: 30px;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), transparent);\n    z-index: 99;\n    opacity: 0;\n}\n\n#leftBar {\n    position: fixed;\n    top: 15px;\n    left: 115px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n\n    flex-wrap: wrap;\n    max-width: 900px;\n    z-index: 100;\n    \n}\n\n#rightBar {\n    position: fixed;\n    top: 15px;\n    right: 30px;\n    width: 500px;\n    text-align: right;\n    z-index: 100;\n}\n\n#logo {\n    position: fixed;\n    top: 16px;\n    left: 25px;\n    height: 22px;\n    z-index: 100;\n    opacity: 0;\n}\n\n#centerLogo{\n    position: fixed;\n    left: 50%;\n    top: 48%;\n    transform: translate(-50%, -50%);\n    width: 160px;\n    z-index: 100110;\n    pointer-events: none;\n    /* border: 1px solid red; */\n}\n\n#hamburger {\n    position: fixed;\n    top: 15px;\n    right: 10px;\n    width: 40px;\n    display: none;\n    z-index: 100;\n    pointer-events: none;\n}\n\n.linkButton {\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 600;\n    font-size: 11px;\n    letter-spacing: 1px;\n    color: #333333;\n    padding-right: 14px;\n    display: inline-block;\n    cursor: pointer;\n    /* transition: transform 0.3s ease-in; */\n    opacity: 0;\n}\n\n.linkButton:hover {\n    text-decoration: underline;  /* Underline on hover */\n    color: #333333;  /* Optional: Change color on hover */\n}\n\n.linkButton:hover {\n    /* transform: translateY(-2px); */\n    /* transition: transform 0.04s ease-out; */\n}\n  \n#mainDivCont{\n\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100vh;\n    z-index: 10;\n    /* opacity: 0; */\n\n    /* -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */\n    /* mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */\n\n}\n\n#mainDiv{\n    position: absolute;\n    width: 100%;\n    /* border: 1px solid red; */\n}\n\n#cursor {\n    position: fixed;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    z-index: 200;\n    background: #ffffff;\n    opacity: .1;\n    pointer-events: none;\n}\n\n#cursor2 {\n    position: fixed;\n    width: 21px;\n    height: 21px;\n    border-radius: 50%;\n    z-index: 200;\n    /* background: #ffffff; */\n    border: 1px solid white;\n    opacity: .2;\n    pointer-events: none;\n}\n\n#tr1 {\n    opacity: 0;\n}\n\n#tr2 {\n    opacity: 0;\n}\n\n#tr3 {\n    opacity: 0;\n}\n\n#tr4 {\n    opacity: 0;\n}\n\n#tr5 {\n    opacity: 0;\n}\n\n#tr6 {\n    opacity: 0;\n}\n\n#tr7 {\n    opacity: 0;\n}\n\n#contactCont{\n    \n    color: #cccccc;\n    position: fixed;\n    height: 100vh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    /* border: 1px solid red; */\n    transform: translateY(-10%);\n    gap: 5px;\n}\n\n#contact1{\n    font-family: \"IM Fell English\", serif;\n    font-style: italic;\n    font-size: 16pt;\n}\n\n#contact2{\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 16pt;\n    letter-spacing: 2px;\n}\n\n#contact3{\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 10pt;\n    letter-spacing: 2px;\n}\n\n#contactCont #contact3 a:hover {\n    color: #cccccc;\n    text-decoration: none;\n  }\n  \n#contact3 a,\n#contact3 a:link,\n#contact3 a:visited,\n#contact3 a:hover,\n#contact3 a:active {\n  color: #cccccc !important;\n  text-decoration: none;\n}\n\n.tmzLink {\n    color: #cccccc;\n    text-decoration: underline;\n  }\n\n@media (max-width: 1370px) {\n    #leftBar {\n        top: 7px;\n        max-width: 450px;\n        /* border: 1px solid red; */\n    }\n}\n\n@media (max-width: 960px) {\n    #tr1 {\n        display: none;\n    }\n    #tr2 {\n        display: none;\n    }\n    #tr3 {\n        display: none;\n    }\n    #tr4 {\n        display: none;\n    }\n}\n\n@media (max-width: 715px) {\n    #canvasHolder,\n    .crt-scanlines,\n    .crt-vignette,\n    .pageGradient {\n        display: none !important;\n    }\n    #leftBar {\n        display: none;\n    }\n    #rightBar {\n        display: none;\n    }\n    #topBar {\n        display: none;\n    }\n    #logo{\n        top: 15px;\n        left: 15px;\n        height: 25px;\n    }\n    #hamburger{\n        /* display: block; */\n    }\n    #topBarGrad{\n        /* display: none; */\n        top: 0px;\n    }\n    \n}\n\n#hamburgerMenu {\n    /* display: none; */\n    opacity: 0;\n    position: fixed;\n    top: 50px;\n    right: 10px;\n    background-color: black;\n    /* padding: 10px; */\n    z-index: 1200;\n    border: 1px solid #444;\n  }\n  \n  .hamburgerLink {\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 14px;\n    letter-spacing: 1px;\n    color: #cccccc;\n    padding: 8px 12px;\n    border-bottom: 1px solid #444444;\n    cursor: pointer;\n  }\n  \n  .hamburgerLink:last-child {\n    border-bottom: none;\n  }\n  \n  .hamburgerLink:hover {\n    background-color: #222;\n  }\n  \n\n/* ------links--------------------------------------------------- */\n\n/*  */\n  \n/* mixer */\n\n#mixer{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
